export default __webpack_public_path__ + "static/media/user.038773ae.jpg";